export const refinancingCarLoanData = [
  {
    id: "step-one",
    stepName: "Review Your Existing Auto Loan",
  },
  {
    id: "step-two",
    stepName: "Determine the Value of Your Car",
  },
  {
    id: "step-three",
    stepName: "Evaluate Your Credit",
  },
  {
    id: "step-four",
    stepName: "Gather Information for Your Application",
  },
  {
    id: "step-five",
    stepName: "Compare Lenders and Rates",
  },

  {
    id: "step-six",
    stepName: "Apply to Refinance Your Car Loan",
  },
];

export const getRefinancingLoanData = [
  {
    id: 1,
    heading: "Car Loan Refinancing Made Simple: Reduce Your EMIs Today",
    subHeading:
      "Refinancing your car loan can help you save money by reducing your monthly payments or interest rates. Learn the step-by-step process and use Minemi’s tools to compare lenders, calculate your savings, and make informed decisions.",
    notice:
      "The information provided is for illustrative purposes only. Loan terms, interest rates, and savings may vary depending on lenders’ policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
